<!-- eslint-disable -->
<script setup>
import { useCustomerStore } from '@/stores/customer';
import NotificationsModal from '@/components/modals/NotificationsModal.vue';
import { openModal } from '@kolirt/vue-modal';
import { useDatesStore } from '@/stores/dates';
import { useNotificationStore } from '@/stores/notifications';
import { useI18n } from 'vue-i18n';

const notificationStore = useNotificationStore()
const dateStore = useDatesStore();
const customerStore = useCustomerStore();
const { t } = useI18n();

const openPopup = (notification) => {
	let payload = {
		page: 1
	};

	notificationStore.selected_notification_id = notification.id;

	if (notification.read_at == null) {
		notificationStore.updateCustomerNotification(notification).then(() => {
			notificationStore.fetchCustomerUnreadNotifications(payload).then(() =>{
				openModal(NotificationsModal, { title: notification.title, body: notification.body, notification: notification }).catch(() => {});
				notificationStore.fetchCustomerNotifications(payload)
			});

		})
	} else {
		openModal(NotificationsModal, { title: notification.title, body: notification.body, notification: notification }).catch(() => {});
	}
};

const notificationTitle = (notification) => {
	if (notification?.title == 'deposit_bonus') return t('popup_notification.deposit_bonus')
	else return notification?.title;
}
</script>
<template>
	<div class="notifications-dropdown-inner">
		<template v-if="customerStore.isLoggedIn">
			<div class="offers-accordion">
				<div class="offers-empty" v-if="customerStore.getCustomerPopUpNotifications.length == 0">
					<p>{{ $t('general.no_notifications') }}</p>
				</div>

				<div @click="openPopup(notification)" v-else class="offers-accordion-inner" v-for="(notification, index) in customerStore.getCustomerPopUpNotifications" :key="notification.id" :class="notification.value == index+'index'? 'active':''" >
					<div class="offers-top-header">
						<h3>{{ notificationTitle(notification) }}</h3>
						<h3 class="side-message-box" :class="{'message-unread': notification.read_at === null}"></h3>
					</div>
					<div class="offers-tab-main" >
						<p class="notification-date" > {{ dateStore.messageDate(notification.created_at) }}</p>
					</div>
				</div>
				<div v-if="customerStore.getCustomerPopUpNotifications" class="user-amount-btn notifications-btn">
					<router-link :to="{ name: 'account-notifications' }">{{ $t('general.go_to_notifications') }}</router-link>
				</div>
			</div>
		</template>

	</div>
</template>
<style scoped>
.offers-accordion .user-amount-btn a{
	color: aliceblue !important;
	display: flex !important;
	justify-content: center !important;
}

.offers-top-header {
	grid-template-columns: 1fr auto;
}
.notifications-btn {
	margin-top: 15px;
}

.offers-empty{
	margin-top: 10px;
}

.message-unread {
	background: var(--secondary);
	border-radius: 50%;
	width: 7px;
	height: 7px;
	display: flex;
	margin-top: 7px;
	position: relative;
	margin-right: 10px;
}

.notification-date {
	font-size: 11px;
	color: var(--list-gray);
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	position: relative;
	display: flex;
	flex-direction: row;
}

p {
	overflow-wrap: break-word;
}
.notifications-main .notifications-dropdown-main .notifications-dropdown-inner .offers-accordion .offers-accordion-inner.active .offers-top-header span {
	transform: unset !important;
}

.notification-inner {
	color: var(--white);
}
</style>